import Vue from 'vue';
import Router from 'vue-router';
import DifyChat from '../views/DifyChat/index.vue';
import Share from '../views/DifyChat/share.vue';
import Login from '../views/login/index.vue';

Vue.use(Router);

// 解决 NavigationDuplicated 错误
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;

Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err;
        }
    });
};

Router.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalReplace.call(this, location, onResolve, onReject);
    }
    return originalReplace.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err;
        }
    });
};

export default new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: {hideInMenu: true},
        },
        {
            path: '/DifyChat/index',
            name: 'DifyChat',
            component: DifyChat,
            meta: {hideInMenu: true},
        },
        {
            path: '/share',
            name: 'share',
            component: Share,
            meta: {hideInMenu: true},
        },
        {
            path: '*',
            redirect: '/',
        },
    ],
});
